module.exports = __webpack_public_path__ + "static/media/PHOTO1.89d54d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PHOTO1.png
// module id = 262
// module chunks = 0